import { CombinedMode } from '@/components/CombinedMode';
import { SplitMode } from '@/components/SplitMode';
import { CombinedView } from './views/combined';
import { LenderView } from './views/lender';
import { ComplianceSubmitModal } from '@/modals/ComplianceSubmitModal';

const DashboardPage = () => {
  return (
    <>
      <ComplianceSubmitModal />
      <CombinedMode>
        <CombinedView />
      </CombinedMode>
      <SplitMode
        lender={<LenderView />}
        borrower={<CombinedView />}
      />
    </>
  );
};

export default DashboardPage;
